import axios from 'axios';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './login.css';

export const Forgot = () => {
  const [email, setEmail]     = useState('');
  const [emailErr, setEmailErr] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState<string | null>(null);
  const [sent, setSent]       = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setEmailErr(false);

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailErr(true);
      return;
    }

    setLoading(true);
    try {
      const res = await axios.get(`existing-user/${email}`);
      if (!res.data.exists) {
        setError('No account found with this email address.');
        return;
      }
      await axios.post('forgot', { email });
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='lp-root'>
      <div className='lp-mesh' />
      <div className='lp-mesh-noise' />

      <div className='lp-page'>
        <div className='lp-right'>
          <div className='lp-form-card'>
            <div className='lp-card-stripe' />
            <div className='lp-card-body'>

              {!sent ? (
                <>
                  <div className='lp-greeting'>Forgot password?</div>
                  <div className='lp-greeting-sub'>
                    Enter your work email and we'll send you a reset link.
                  </div>

                  {error && <div className='lp-err-banner'>{error}</div>}

                  <form onSubmit={handleSubmit}>
                    <div className={`lp-field${emailErr ? ' lp-error' : ''}`}>
                      <div className='lp-field-label'><span>Work email</span></div>
                      <div className='lp-inp-wrap'>
                        <span className='lp-inp-icon'>
                          <FontAwesomeIcon icon={faEnvelope} />
                        </span>
                        <input
                          className='lp-inp'
                          type='email'
                          placeholder='you@company.com'
                          autoComplete='email'
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                        />
                      </div>
                      {emailErr && <div className='lp-field-error'>⚠ Please enter a valid email</div>}
                    </div>

                    <button type='submit' className='lp-btn-submit' disabled={loading} style={{ marginTop: 8 }}>
                      {loading
                        ? <><div className='lp-spinner' /><span>Sending…</span></>
                        : <><span>Send reset link</span><span className='lp-btn-arrow'>→</span></>
                      }
                    </button>
                  </form>

                  <div className='lp-back-row'>
                    <Link to='/login' className='lp-back-link'>
                      <FontAwesomeIcon icon={faArrowLeft} />
                      Back to Sign in
                    </Link>
                  </div>
                </>
              ) : (
                <div className='lp-sent-wrap'>
                  <div className='lp-sent-icon'>✉</div>
                  <div className='lp-greeting' style={{ marginTop: 18 }}>Check your inbox</div>
                  <div className='lp-greeting-sub' style={{ marginBottom: 0 }}>
                    We've sent a password reset link to<br />
                    <strong style={{ color: 'var(--lp-txt)' }}>{email}</strong>
                  </div>
                  <div className='lp-back-row' style={{ marginTop: 28 }}>
                    <Link to='/login' className='lp-back-link'>
                      <FontAwesomeIcon icon={faArrowLeft} />
                      Back to Sign in
                    </Link>
                  </div>
                </div>
              )}

            </div>
          </div>

          <div className='lp-trust-row'>
            <div className='lp-trust-item'>🔒 <span>256-bit SSL</span></div>
            <div className='lp-trust-dot' />
            <div className='lp-trust-item'>🛡 <span>GDPR compliant</span></div>
          </div>
        </div>
      </div>
    </div>
  );
};
